import { Badge } from "./ui/badge";
import { Tip } from "./ui/tooltip";

/** Marks data from src/lib/stubs.ts so nobody mistakes it for real data. */
export function SampleBadge({ stream }: { stream: string }) {
  return (
    <Tip text={`Sample data until the ${stream} module lands`}>
      <Badge variant="warning" tabIndex={0}>
        sample
      </Badge>
    </Tip>
  );
}
